import { CardWithC2CssProps } from './CssConfig';

export const hireConfigs = [
  {
    componentReference: 'title',
    label: 'Hires',
    id: 'hires-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 6,
  },

  // cards
  {
    componentReference: 'container',
    id: 'hires-cards-container',
    children: [
      {
        containerType: 'hires',
        componentType: 'card',
        componentReference: 'card',
        id: 'hires_no_of_hires',
        selected: false,
        cssProps: CardWithC2CssProps,
        ui: {
          renderType: 'card',
          header: 'Completed Interviews',
          id: 'interviews',
          value: 10,
          topLabel: 'Hires',
          bottomLabel: 'HIRES',
        },
        api: {
          subject_type: 'hires',
          metadata: {
            tileKey: 'hires_no_of_hires',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'hires',
            id: 'hires_no_of_hires',
          },
        },
      },
      {
        containerType: 'hires',
        componentType: 'card',
        componentReference: 'card',
        id: 'hires_time_to_hire',
        selected: false,
        cssProps: CardWithC2CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'hires_time_to_hire',
          value: '4 Days',
          topLabel: 'Time to hire',
          bottomLabel: 'HIRE',
        },
        api: {
          subject_type: 'hires',
          metadata: {
            tileKey: 'hires_time_to_hire',
            componentType: 'card',
            apiParam: 'card',
            calculationType: 'avgChange',
            unit: 'time',
            metricKeys: {
              numerator: 'time_to_hire',
              denominator: 'hires',
            },
            id: 'hires_time_to_hire',
          },
        },
      },
    ],
  },

  // trend chart
  {
    containerType: 'hires',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'hires_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Hire trend',
      id: 'hires_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [0, 0, 0, 27, 13],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'hires',
      metadata: {
        tileKey: 'hires_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'hires_trend_chart',
      },
    },
  },

  //visual charts
  {
    componentReference: 'container',
    id: 'hires-trend-chart-container-set1',
    children: [
      // visual chart 1
      {
        containerType: 'hires',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'hires_department_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Hires by department',
          id: 'hires_department_chart',
          chartData: {
            series: [
              {
                name: 'GTM',
                y: 4,
              },
              {
                name: 'Product',
                y: 2,
              },
              {
                name: 'Exec',
                y: 2,
              },
              {
                name: 'Accessbility',
                y: 1,
              },
              {
                name: 'Sales',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'hires',
          metadata: {
            tileKey: 'hires_department_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'department',
            },
            headerKeys: [],
            id: 'hires_department_chart',
          },
        },
      },

      //visual chart 2
      {
        containerType: 'hires',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'hires_source_chart',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Hires by source (on application)',
          id: 'hires_source_chart',
          chartData: {
            categories: ['No source', 'linkedin'],
            series: [10, 12],
          },
          chartType: 'bar',
        },
        api: {
          subject_type: 'hires',
          metadata: {
            tileKey: 'hires_source_chart',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'appl_contact_source',
            },
            headerKeys: [],
            id: 'hires_source_chart',
          },
        },
      },
    ],
  },

  // table
  {
    containerType: 'hires',
    componentType: 'table',
    componentReference: 'table',
    id: 'hires_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Hire breakdown',
      id: 'hires_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          hires: 0,
          time_to_hire: 0,
          hires_total: 10,
          hires_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          hires: 0,
          time_to_hire: 0,
          hires_total: 10,
          hires_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          hires: 0,
          time_to_hire: 0,
          hires_total: 10,
          hires_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          hires: 5,
          time_to_hire: 3805758,
          hires_total: 10,
          hires_per: '50.0',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          hires: 5,
          time_to_hire: 926,
          hires_total: 10,
          hires_per: '50.0',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'hires',
      metadata: {
        tileKey: 'hires_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'hires_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'hires_table',
      },
    },
  },
];

export const hiresLayoutConfig = [
  {
    key: 'hires_no_of_hires',
    x: 0,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'hires_time_to_hire',
    x: 4,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'hires_trend_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'hires_department_chart',
    x: 0,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'hires_source_chart',
    x: 6,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'hires_table',
    x: 0,
    y: 51,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
